import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import SettingTop from './SettingTop';
import FarmList from './FarmList';
import FarmDetail from './FarmDetail';
import UserInfoUpdate from './UserInfoUpdate';
import UserPasswordUpdate from './UserPasswordUpdate';
import GroupInfoUpdate from './GroupInfoUpdate';

// 画面遷移作成
const MainStack = createNativeStackNavigator();

/** ================================
*  設定画面ナビゲーション
*  ================================*/
export default function SettingNavigator() {
  return (
    <MainStack.Navigator screenOptions={{ headerShown: false }}>
      <MainStack.Screen name="SettingTop" component={SettingTop} options={{ title: '設定' }} />
      <MainStack.Screen name="FarmList" component={FarmList} options={{ title: '圃場一覧' }} />
      <MainStack.Screen name="FarmDetail" component={FarmDetail} options={{ title: '圃場詳細' }} />
      <MainStack.Screen name="UserInfoUpdate" component={UserInfoUpdate} options={{ title: 'ユーザ情報変更' }} />
      <MainStack.Screen name="UserPasswordUpdate" component={UserPasswordUpdate} options={{ title: 'ユーザパスワード変更' }} />
      <MainStack.Screen name="GroupInfoUpdate" component={GroupInfoUpdate} options={{ title: '組織情報変更' }} />
    </MainStack.Navigator>
  );
}
